import { mutationTypes } from './access-keys'

export default {
  [mutationTypes.root.SET_API_ERRORS](state, errorObj) {
    state.apiErrors = errorObj
  },
  [mutationTypes.root.CLEAR_API_ERRORS](state) {
    state.apiErrors = null
  }
}
